import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAutoComplete, LazyCheckbox, LazyDatePicker, LazyInputNumber, LazyInputText, LazyButton, LazyConfirmDialog } from '#components'
const lazyGlobalComponents = [
  ["AutoComplete", LazyAutoComplete],
["Checkbox", LazyCheckbox],
["DatePicker", LazyDatePicker],
["InputNumber", LazyInputNumber],
["InputText", LazyInputText],
["Button", LazyButton],
["ConfirmDialog", LazyConfirmDialog],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
